<mat-button-toggle-group
  cdkDrag
  class="mat-elevation-z4"
  [value]="submissionId"
  (change)="switchAnswer($event.value)"
>
  <mat-button-toggle cdkDragHandle disabled class="handle">
    <div class="spacer"></div>
    <mat-icon class="material-icons" *ngIf="(isLoading | async) === false"
      >compare_arrows</mat-icon
    >
    <mat-spinner *ngIf="isLoading | async" [diameter]="24"></mat-spinner>
  </mat-button-toggle>
  <mat-button-toggle
    *ngIf="hasDefaultAnswers$ | async"
    [value]="defaultAnswersId"
  >
    D
  </mat-button-toggle>
  <mat-button-toggle
    *ngFor="let item of submissionItems$ | async"
    [value]="item.id"
  >
    <div class="spacer"></div>
    {{ item.name }}
  </mat-button-toggle>
  <mat-button-toggle *ngIf="hasTrainingAnswers" (click)="loadTrainingTask()">
    Gold answer
  </mat-button-toggle>
  <mat-button-toggle (click)="resetAnswerAndCloseOverlay()">
    <div class="spacer"></div>
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
